import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { graphql } from 'gatsby'
import React from 'react'

import useSiteSettings from '../../../../hooks/useSiteSettings'
import {
  facebookIcon,
  instagramIcon,
  linkedInIcon,
  xIcon,
  youtubeicon,
} from '../../../../lib/custom-icons'
import ScreenReaderOnly from '../../../ScreenReaderOnly'
import { cn } from '../../../utils/cn'
import Link from '../../Link'

interface SocialMediaMenuProps {
  isPrinting?: boolean
}

library.add(facebookIcon, instagramIcon, xIcon, youtubeicon, linkedInIcon)

const SocialMediaMenu: React.FC<SocialMediaMenuProps> = ({ isPrinting = false }) => {
  const { footerSocialMenu: menuEntries } = useSiteSettings() || {}

  return (
    <ul className={cn('flex', isPrinting ? 'gap-[1.125rem]' : 'gap-[30px] mt-[37.36px] md:mt-0')}>
      {menuEntries &&
        menuEntries.reduce((acc: React.ReactElement[], entry) => {
          if (!entry) return acc
          const { name: entryName, link } = entry
          const { href, blank } = link || {}
          if (!entryName || !href) return acc
          acc.push(
            <li key={entryName}>
              <Link to={href} target={blank != null ? '_blank' : undefined}>
                <ScreenReaderOnly>{entryName}</ScreenReaderOnly>
                <FontAwesomeIcon
                  size={isPrinting ? 'sm' : 'lg'}
                  icon={
                    typeof entry.icon === 'string' && entry.icon.startsWith('[')
                      ? JSON.parse(entry.icon)
                      : entry.icon
                  }
                />
              </Link>
            </li>,
          )
          return acc
        }, [])}
    </ul>
  )
}

export { SocialMediaMenu }

export const footerSocialMenu = graphql`
  fragment footerSocialMenuFragment on SanitySiteSettings {
    footerSocialMenu {
      name
      icon
      link {
        href
        blank
      }
    }
  }
`
